<template>
  <span v-if="rowColor" :style="{ color: rowColor }">
    <i class="fa fa-lg fa-square status"></i>
  </span>
</template>

<script>
export default {

  props: ['row', 'src'],

  computed: {

    rowColor () {
      const arr = this.src.split('.')
      let target = arr.length - 2

      if (target < 0) target = 0

      if (this.row[arr[target]] === undefined) return false

      if (!this.row[arr[target]]) return false

      if (this.row[arr[target]].color !== undefined) {
        return this.row[arr[target]].color
      }

      return false
    }

  }

}
</script>



// WEBPACK FOOTER //
// src/components/Elements/ColumnIcon.vue